
<mat-horizontal-stepper labelPosition="bottom"  #stepper>
    <mat-step [stepControl]="personalDataFormGroup" completed="false">
        <form [formGroup]="personalDataFormGroup">
            <ng-template matStepLabel>Dados pessoais</ng-template>
            <h5>Endereço</h5>
            <mat-form-field class="w-25">
                <mat-label>CEP</mat-label>
                <input matInput formControlName="cep" [textMask]="{mask: MASKS.cep.textMask}" (blur)="getAddress(personalDataFormGroup.get('cep').value)">
                <!-- <mat-error *ngIf="(personalDataFormGroup.get('cep').invalid && (personalDataFormGroup.get('cep').dirty || personalDataFormGroup.get('cep').touched)) && personalDataFormGroup.get('cep').errors.cep">
                    CEP inválido.
                </mat-error>
                <mat-error *ngIf="(personalDataFormGroup.get('cep').invalid && (personalDataFormGroup.get('cep').dirty || personalDataFormGroup.get('cep').touched)) && personalDataFormGroup.get('cep').errors.required">
                    CEP é obrigatório!
                </mat-error> -->
                <mat-error *ngIf="(personalDataFormGroup.get('cep').invalid && (personalDataFormGroup.get('cep').dirty || personalDataFormGroup.get('cep').touched)) && personalDataFormGroup.get('cep').errors.required">
                    CEP é obrigatório!
                </mat-error>
            </mat-form-field>
            <table class="w-75" cellspacing="0">
                <tr>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Endereço</mat-label>
                            <input matInput formControlName="address">
                        </mat-form-field>
                        <mat-error *ngIf="(personalDataFormGroup.get('address').invalid && (personalDataFormGroup.get('address').dirty || personalDataFormGroup.get('address').touched)) && personalDataFormGroup.get('address').errors.required">
                            Endereço é obrigatório!
                        </mat-error>
                    </td>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Número</mat-label>
                            <input matInput formControlName="number" maxlength="10">
                        </mat-form-field>
                        <mat-error *ngIf="(personalDataFormGroup.get('number').invalid && (personalDataFormGroup.get('number').dirty || personalDataFormGroup.get('number').touched)) && personalDataFormGroup.get('number').errors.required">
                            Número é obrigatório!
                        </mat-error>
                    </td>
                </tr>
                <tr>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Complemento</mat-label>
                            <input formControlName="complement" matInput >
                        </mat-form-field>
                    </td>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Bairro</mat-label>
                            <input matInput formControlName="neighborhood">
                        </mat-form-field>
                        <mat-error *ngIf="(personalDataFormGroup.get('neighborhood').invalid && (personalDataFormGroup.get('neighborhood').dirty || personalDataFormGroup.get('neighborhood').touched)) && personalDataFormGroup.get('neighborhood').errors.required">
                            Bairro é obrigatório!
                        </mat-error>
                    </td>
                </tr>
                <tr>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Cidade</mat-label>
                            <input matInput formControlName="city" [readonly]="emptyCity">
                        </mat-form-field>
                        <mat-error *ngIf="(personalDataFormGroup.get('city').invalid && (personalDataFormGroup.get('city').dirty)) && personalDataFormGroup.get('city').errors.required" >
                            Cidade é obrigatório!
                        </mat-error>
                    </td>
                    <td>
                        <mat-form-field class="w-75">
                        <mat-label>Estado</mat-label>
                            <input matInput formControlName="uf" maxlength="2" [readonly]="emptyUf">
                        </mat-form-field>
                        <mat-error *ngIf="(personalDataFormGroup.get('uf').invalid && (personalDataFormGroup.get('uf').dirty)) && personalDataFormGroup.get('uf').errors.required">
                            Estado é obrigatório!
                        </mat-error>
                    </td>
                </tr>
            </table>
            <h5>Documentos</h5>
            <label>Foto do rosto</label>
            <br>
            <app-upload-arquivo [accept]="accept" (file)="setFile($event,1)"></app-upload-arquivo>
            <div *ngIf="showErrorPersonPicture" >
                <span style="color:red">A imagem de rosto é obrigatória!</span>
            </div>
            <label class="mt-3">RG/CNH (frente)</label>
            <br>
            <app-upload-arquivo [accept]="accept" (file)="setFile($event,2)"></app-upload-arquivo>
            <div *ngIf="showErrorPrincipalAttachment">
                <span style="color:red">A imagem da frente do documento é obrigatória!</span>
            </div>
            <label class="mt-3">RG/CNH (verso)</label>
            <br>
            <app-upload-arquivo [accept]="accept" (file)="setFile($event,3)"></app-upload-arquivo>
            <div *ngIf="showErrorAuxAttachment">
                <span style="color:red">A imagem do verso do documento é obrigatória!</span>
            </div>
            <div class="mt-2">
                <button mat-button class="custom-modal-button" (click)="goForward(stepper)">Próximo</button>
            </div>
        </form>
    </mat-step>
    <mat-step [stepControl]="cardDataFormGroup">
        <form [formGroup]="cardDataFormGroup">
        <ng-template matStepLabel>Vincular cartão</ng-template>
        <mat-form-field>
          <mat-label>Número do cartão</mat-label>
          <input matInput formControlName="cardNumber" placeholder="0000 0000 0000 0000" [textMask]="{mask: cardmask}" (blur)="getPan(cardDataFormGroup.get('cardNumber').value)">
        </mat-form-field>
        <mat-error *ngIf="(cardDataFormGroup.get('cardNumber').invalid && (cardDataFormGroup.get('cardNumber').dirty || cardDataFormGroup.get('cardNumber').touched)) && cardDataFormGroup.get('cardNumber').errors.required">
            Número do cartão é obrigatório!
        </mat-error>
        <mat-error *ngIf="!isValidPan && showErrorPan && cardDataFormGroup.get('cardNumber').valid">
            Número do cartão é inválido!
        </mat-error>
        <mat-error *ngIf="!canBindNewUser && showErrorBindNewUser && cardDataFormGroup.get('cardNumber').valid">
            Esse número do cartão já está sendo utilizado!
        </mat-error>
        <table class="w-75" cellspacing="0" *ngIf="isValidPan && canBindNewUser">
            <tr>
                <td>
                    <mat-form-field class="w-75">
                        <mat-label>CVV</mat-label>
                        <input matInput formControlName="cvv" placeholder="000" maxlength="3">
                    </mat-form-field>
                    <mat-error *ngIf="(cardDataFormGroup.get('cvv').invalid && (cardDataFormGroup.get('cvv').dirty || cardDataFormGroup.get('cvv').touched)) && cardDataFormGroup.get('cvv').errors.required">
                        CVV é obrigatório!
                    </mat-error>
                </td>
                <td>
                    <mat-form-field class="w-75">
                        <mat-label>Data de Validade</mat-label>
                        <input matInput formControlName="expirationDate" placeholder="MM/YY" [textMask]="{mask: datemask}">
                    </mat-form-field>
                    <mat-error *ngIf="(cardDataFormGroup.get('expirationDate').invalid && (cardDataFormGroup.get('expirationDate').dirty || cardDataFormGroup.get('expirationDate').touched)) && cardDataFormGroup.get('expirationDate').errors.required">
                        Data de Validade é obrigatório!
                    </mat-error>
                </td>
            </tr>
        </table>
        <div>
          <!-- <button mat-button matStepperPrevious>Back</button> -->
          <button mat-button class="custom-modal-button" [disabled]="!bindcard" (click)="bindCard(stepper)">Próximo</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Concluído</ng-template>
      <p>Será enviado um SMS com a Senha do cartão para o telefone: <b>{{collaborator.phoneNumber | telefone}}</b></p>
      <div>
        <button mat-button (click)="redirectList()" class="custom-modal-button">Concluir</button>
        <!-- <button mat-button matStepperPrevious class="custom-modal-button button-cancel mr-2">Anterior</button> -->
      </div>
    </mat-step>
  </mat-horizontal-stepper>
